export default __webpack_public_path__ + "static/media/discordIcon.0fda5d6b.svg";